module.exports = ["3g2","3gp","aaf","asf","avchd","avi","drc","flv","m2v","m4p","m4v","mkv","mng","mov","mp2","mp4","mpe","mpeg","mpg","mpv","mxf","nsv","ogg","ogv","qt","rm","rmvb","roq","svi","vob","webm","wmv","yuv"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/video-extensions/video-extensions.json
// module id = 56
// module chunks = 0